import {createSelector} from "reselect";
import {AppState} from "../../index";
import {IBannerVariables, VariablesType} from "./types";
import {ISelectOption} from "../../../components/FuseSelect";
import createCachedSelector from "re-reselect";
import {sortByStringProp} from "../../../utils/sort";

const selectBannerVariables = (state: AppState) => state.bannerVariables.bannerVariables
const selectActiveDesignBannerVariables = (state: AppState) => state.bannerVariables.activeDesignBannerVariables
const selectActiveMasterDesignBannerVariables = (state: AppState) => state.bannerVariables.activeMasterDesignBannerVariables
const selectActiveFeedBannerVariables = (state: AppState) => state.bannerVariables.activeFeedBannerVariables
const selectActiveMasterFeedBannerVariables = (state: AppState) => state.bannerVariables.activeMasterFeedBannerVariables
const selectBannerVariablesLoading = (state: AppState) => state.bannerVariables.isLoading

export const createSelectActiveBannerVariables = (state: AppState, variablesType: VariablesType, selectMaster: boolean) =>
    createSelector(
        [selectActiveDesignBannerVariables, selectActiveMasterDesignBannerVariables, selectActiveFeedBannerVariables, selectActiveMasterFeedBannerVariables],
        (activeDesign, activeMasterDesign, activeFeed, activeMasterFeed): IBannerVariables => {
            if (variablesType === VariablesType.DESIGN) {
                if (selectMaster) {
                    return activeMasterDesign
                }
                return activeDesign
            } else if (variablesType === VariablesType.FEED) {
                if (selectMaster) {
                    return activeMasterFeed
                }
                return activeFeed
            } else {
                return activeDesign
            }
        })(state)

export const createSelectBannerVariablesOptions = createCachedSelector(
    selectBannerVariables,
    (state: AppState, variablesType: string) => variablesType,
    (state: AppState, variablesType: string, selectMaster: boolean) => selectMaster,
    (bannerVariables, variablesType, selectMaster): ISelectOption[] => {
        let values = Object.values(bannerVariables.byId);
        if (selectMaster) {
            values = values.filter((item) => item.isMaster && item.variablesType === variablesType)
        } else {
            values = values.filter((item) => item.variablesType === variablesType)
        }
        return values.map((item) => {
            return {value: item.id, text: `${item.name}`}
        }).sort((a, b): number => {
            return sortByStringProp(a, b, "text")
        })
    }
)(
    (state, variablesType, selectMaster) => {
        return `${variablesType}:${selectMaster}`
    }
)

export const createSelectParentOfBannerVariables = (state: AppState, bannerVariables: IBannerVariables) =>
    createSelector(
        [selectBannerVariables],
        (bannerVariablesList): IBannerVariables | null => {
            const id = bannerVariables.parentId
            if (id && bannerVariablesList.byId[id]) {
                return bannerVariablesList.byId[id]
            }
            return null
        })(state)

export {
    selectBannerVariables,
    selectActiveDesignBannerVariables,
    selectActiveMasterDesignBannerVariables,
    selectBannerVariablesLoading,
}